"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _unique = _interopRequireDefault(require("../helpers/unique.id"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _rating = _interopRequireDefault(require("./rating"));

var _ratingStatefulOption = _interopRequireDefault(require("./ratingStatefulOption"));

var _color = _interopRequireDefault(require("../../constants/color"));

var _icon = _interopRequireDefault(require("../Icon/icon"));

var _ratingUtil = require("./rating-util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var colorPalette = [_color.default.background.orange[700], _color.default.background.orange[500], _color.default.background.yellow[600], _color.default.background.green[500], _color.default.background.green[700]];
var neutralColor = _color.default.background.gray[600];

var neutralRatingOption = function neutralRatingOption(small) {
  return _react.default.createElement(_ratingStatefulOption.default, {
    name: "neutral",
    key: 'neutral'
  }, _react.default.createElement(_icon.default, {
    name: _icon.default.BLOCK,
    medium: !small
  }));
};

var RatingStateful =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RatingStateful, _React$Component);

  function RatingStateful(props) {
    var _this;

    _classCallCheck(this, RatingStateful);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RatingStateful).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      _this.setState({
        selectedOptionIndex: event.target.index,
        childrenColor: _this.getOptionsColors(event.target.index, 'change')
      }, _this.props.onChange(event.target.value));
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (event) {
      _this.setState({
        childrenColor: _this.getOptionsColors(event.target.index, 'enter')
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      _this.setState({
        childrenColor: _this.getOptionsColors(_this.state.selectedOptionIndex, 'leave')
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClear", function () {
      _this.setState({
        selectedOptionIndex: null,
        childrenColor: _this.getOptionsColors(-1)
      }, _this.props.onClear());
    });

    var _this$props = _this.props,
        children = _this$props.children,
        id = _this$props.id,
        neutralOption = _this$props.neutralOption,
        small = _this$props.small,
        defaultSelected = _this$props.defaultSelected;
    _this.ratingId = id || (0, _unique.default)();
    _this.children = neutralOption ? [].concat(_toConsumableArray(_react.default.Children.toArray(children)), [neutralRatingOption(small)]) : children;
    var selectedOptionIndex = defaultSelected === 'neutral' ? _this.children.length - 1 : _this.defaultSelectedIndex(children, defaultSelected);
    _this.state = {
      childrenColor: _this.getOptionsColors(selectedOptionIndex),
      selectedOptionIndex: selectedOptionIndex
    };
    return _this;
  }

  _createClass(RatingStateful, [{
    key: "defaultSelectedIndex",
    value: function defaultSelectedIndex(children, defaultSelected) {
      return defaultSelected && _react.default.Children.toArray(children).findIndex(function (child) {
        return defaultSelected === child.props.name;
      });
    }
  }, {
    key: "getOptionsColors",
    value: function getOptionsColors(selectedOptionIndex, action) {
      var _this2 = this;

      if (selectedOptionIndex === -1) {
        return Array(_react.default.Children.count(this.props.children));
      }

      var selectedColor = this.calculateColorIndex(selectedOptionIndex);
      return _react.default.Children.map(this.children, function (child, index) {
        if (_this2.props.unique) {
          if (index === selectedOptionIndex) return selectedColor;
          if (action === 'enter' && _this2.state.selectedOptionIndex === index) return _this2.state.childrenColor[index];
          return false;
        }

        return index <= selectedOptionIndex ? selectedColor : false;
      });
    }
  }, {
    key: "calculateColorIndex",
    value: function calculateColorIndex(selectedOptionIndex) {
      var numberOptions = _react.default.Children.count(this.props.children);

      var index = Math.floor(selectedOptionIndex * colorPalette.length / numberOptions);

      if (numberOptions === 3) {
        index = selectedOptionIndex * 2;
      }

      return colorPalette[index] || neutralColor;
    }
  }, {
    key: "processChildren",
    value: function processChildren(children) {
      var _this3 = this;

      var names = [];
      return _react.default.Children.map(children, function (child, index) {
        var childName = child.props.name;

        if (childName) {
          if (names.includes(childName)) {
            console.error("RatingStateful component: You must not have two options with the same name: ".concat(childName, "."));
          }

          names.push(childName);
        }

        return _react.default.cloneElement(child, {
          key: index,
          backgroundColor: _this3.state.childrenColor[index] || null,
          selected: _this3.state.selectedOptionIndex === index
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          tabIndex = _this$props2.tabIndex,
          small = _this$props2.small,
          large = _this$props2.large,
          disabled = _this$props2.disabled,
          onClear = _this$props2.onClear;
      var showClearButton = onClear && typeof this.state.selectedOptionIndex === 'number';
      return _react.default.createElement(_rating.default, _extends({
        id: this.ratingId,
        tabIndex: tabIndex,
        onChange: this.handleChange,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onClear: showClearButton ? this.handleClear : null,
        small: small,
        large: large,
        disabled: disabled
      }, (0, _getNativeProps.default)(this.props)), this.processChildren(this.children));
    }
  }]);

  return RatingStateful;
}(_react.default.Component);

var exclusiveSizes = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('small', 'large');
RatingStateful.propTypes = {
  /** {---} One of: @@string@@ @@number@@ @@<Icon>@@ */
  children: _propTypes.any.isRequired,
  id: _propTypes.string,
  tabIndex: _propTypes.string,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  small: exclusiveSizes,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  large: exclusiveSizes,
  disabled: _propTypes.bool,
  unique: _propTypes.bool,
  onChange: _propTypes.func,

  /** {func} Mutually exclusive props: @@onClear@@ @@neutralOption@@ */
  onClear: _ratingUtil.mutuallyExclusiveUniqueClear,

  /** {bool} Mutually exclusive props: @@onClear@@ @@neutralOption@@; Required if @@defaultSelected@@ is defined to @@'neutral'@@ */
  neutralOption: _ratingUtil.mutuallyExclusiveUniqueClear,

  /** {string} Expects the @@name@@ of the @@<RatingStateful.Option>@@ to be selected by default. If the neutral option is selected by default, "neutral" should be passed here */
  defaultSelected: _ratingUtil.requireNeutralIfDefaultSelectionIsNeutral
};
RatingStateful.Option = _ratingStatefulOption.default;
var _default = RatingStateful;
exports.default = _default;
RatingStateful.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "defaultSelectedIndex",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "children",
      "type": null
    }, {
      "name": "defaultSelected",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getOptionsColors",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "selectedOptionIndex",
      "type": null
    }, {
      "name": "action",
      "type": null
    }],
    "returns": null
  }, {
    "name": "calculateColorIndex",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "selectedOptionIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleMouseEnter",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleMouseLeave",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleClear",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "processChildren",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "children",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "RatingStateful",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} One of: @@string@@ @@number@@ @@<Icon>@@"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "tabIndex": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "small": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "large": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "unique": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onClear": {
      "type": {
        "name": "custom",
        "raw": "mutuallyExclusiveUniqueClear"
      },
      "required": false,
      "description": "{func} Mutually exclusive props: @@onClear@@ @@neutralOption@@"
    },
    "neutralOption": {
      "type": {
        "name": "custom",
        "raw": "mutuallyExclusiveUniqueClear"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@onClear@@ @@neutralOption@@; Required if @@defaultSelected@@ is defined to @@'neutral'@@"
    },
    "defaultSelected": {
      "type": {
        "name": "custom",
        "raw": "requireNeutralIfDefaultSelectionIsNeutral"
      },
      "required": false,
      "description": "{string} Expects the @@name@@ of the @@<RatingStateful.Option>@@ to be selected by default. If the neutral option is selected by default, \"neutral\" should be passed here"
    }
  }
};